module.exports = __webpack_public_path__ + "WorkSans-Thin.cc62024e6d20a2699b38.ttf";


//////////////////
// WEBPACK FOOTER
// D:/F210-INGRESO/cambio_enlace_ayuda/rec_ng_ingresorenta210/src/assets/fonts_v2/Work_Sans/WorkSans-Thin.ttf
// module id = ../../../../../src/assets/fonts_v2/Work_Sans/WorkSans-Thin.ttf
// module chunks = styles